import { Overlay } from 'components/atomic/atoms/overlay';
import Text from 'components/atomic/atoms/text';
import { TextLink } from 'components/atomic/atoms/text-link';
import { ComplianceData } from './format-compliance';

export interface ComplianceOverlayProps {
  data: ComplianceData;
  onClick?: () => void;
  borderRadius?: number | string;
  opacity?: number;
}

export function ComplianceOverlay({ data, onClick, borderRadius = 0, opacity }: ComplianceOverlayProps) {
  if (!data.shouldShow) {
    return null;
  }

  return (
    <Overlay
      variant="dark"
      borderRadius={borderRadius}
      opacity={opacity}
      onClick={onClick}
    >
      <Text component="span" sx={{ width: '50%', maxWidth: '20em' }}>
        {data.message}
        {onClick && <TextLink>{data.ctaText}</TextLink>}
      </Text>
    </Overlay>
  );
}
